import React from 'react'
import Imagery from '../imagery/components/Imagery'


const ImageryPanel: React.FC = () => {
  return (
    <aside id="sidebar">
      <section>
        <h3>Imagery</h3>
        <h4>Basemaps</h4>
        <Imagery label="2023" />
        <Imagery label="2020" />
        <Imagery label="2017" />
        <Imagery label="2014" />
        <Imagery label="2010" />
        <Imagery label="2009" />
        <Imagery label="2008" />
        <Imagery label="2005" />
        <Imagery label="2001" />
        <Imagery label="1998" />
      </section>
    </aside>
  )
}

export default ImageryPanel